import { Alert, Button, ListCard } from "@hagerty/self-service-components";
import styles from "./CoveragesListCard.module.scss";
import { useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/Tag.types";
import { Link } from "../../Link";
import { getStateName, phoneNumbers, PolicyDetails } from "shared";
import { useState } from "react";
import { mt } from "../../../utils/tracking";
import { validateState } from "@hagerty/self-service-components/api/utils";

export type CoveragesListCardProps = {
  policy: PolicyDetails;
};

const editCoveragesTagAction: TagAction = {
  actionName: "Edit coverages",
  actionType: "button",
};

const AlertDesc = () => (
  <>
    This doesn’t cover damages while on the road. To modify or add coverages,
    please contact Hagerty’s Member Service Center at{" "}
    <Link className={styles.phoneLink} phoneNumber={phoneNumbers.auto}>
      {phoneNumbers.auto}
    </Link>
    .
  </>
);

export const CoveragesListCard = ({ policy }: CoveragesListCardProps) => {
  const [redirectEditCoverages, setRedirectEditCoverages] = useState(false);
  const urls = useUrls();
  const { policyCoverages, stateRegion, country, hasIdCard, compOnlyType } =
    policy;

  const onClickEditCoverages = () => {
    mt.trackAction(editCoveragesTagAction);
    setRedirectEditCoverages(true);
  };

  return (
    <ListCard>
      <ListCard.Header>Policy Coverages</ListCard.Header>
      <ListCard.ExpandableRows
        maxRowCount={5}
        viewRowsLabel="View coverages"
        hideRowsLabel="Hide coverages"
        hasFooter={hasIdCard}
      >
        {!hasIdCard && compOnlyType !== "EXCESS_TPL" && (
          <Alert
            className={styles.compOnlyAlert}
            variant="info"
            title={`You only have Comprehensive coverage for your
              ${getStateName(validateState(stateRegion))} policy.`}
            desc={<AlertDesc />}
          />
        )}
        {policyCoverages.map(({ name, limit }, index) => (
          <ListCard.Row key={index}>
            <div className={styles.row}>
              <div className={styles.name}>{name}</div>
              <div className={styles.value}>{limit}</div>
            </div>
          </ListCard.Row>
        ))}
      </ListCard.ExpandableRows>

      {hasIdCard && (
        <ListCard.Footer>
          <Button
            className={styles.editCoveragesButton}
            as="a"
            size="s"
            variant="outlined"
            aria-label="Edit coverages"
            href={urls.insurance.editCoverages(country)}
            onClick={onClickEditCoverages}
            isLoading={redirectEditCoverages}
          >
            Edit coverages
          </Button>
        </ListCard.Footer>
      )}
    </ListCard>
  );
};
